import * as React from 'react';
import * as styles from './Project.css';
// import Carousel from 'nuka-carousel';
import Close from 'react-material-icons/icons/navigation/close';
import { Ribbon } from './Ribbon';

import * as classnames from 'classnames';

export interface ProjectState {
    id: string;
    title: string;
    subtitle?: string;
    summary: string;
    paragraphs?: [string];
    events?: [string];
    tags?: [string];
    tech?: [string];
    date: string;
    icon: string;
    imgs: [string];
    award?: string;
    awards?: [string];
    links?: [{ text: string, url: string }];
    readmore?: [{ text: string, url: string, img: string }];
}

interface Props {
    data: ProjectState;
}

interface State {
    open: boolean;
    closing: boolean;
}

export class Project extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const open = window.location.search.includes(props.data.id);

        this.state = {
            open,
            closing: false
        };

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onOpen() {
        this.setState({ open: true });

        document.body.classList.toggle('noscroll', true);
    }

    onClose() {
        this.setState({ closing: true });
        setTimeout(
            () => {
                this.setState({ closing: false, open: false });
            },
            300
        );

        document.body.classList.toggle('noscroll', false);
    }

    render() {
        const {
            id,
            title,
            subtitle,
            events,
            tags,
            tech,
            date,
            imgs,
            summary,
            paragraphs,
            award,
            awards,
            links,
            readmore
        } = this.props.data;
        const backgroundUrl = imgs && imgs[0] ? `${process.env.PUBLIC_URL}/imgs/projects/${imgs[0]}` : ``;

        // const colors = ['#242950', '#452450', '#50243c', '#255024', '#244650', '#4b5024', '#503c24', '#502a24'];
        // const backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        const backgroundColor = '#003';
        return (
            <div
                className={styles.container}
            >
                <div
                    className={styles.card}
                    onClick={this.onOpen}
                    style={{
                        backgroundColor: backgroundColor
                    }}
                >
                    {award &&
                        <Ribbon text={award} />
                    }
                    <div
                        className={styles.image}
                        style={{
                            backgroundImage: `url(${backgroundUrl})`
                        }}
                    />
                    <div className={styles.titles}>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.subtitle}>{subtitle}</div>
                    </div>
                    <div className={styles.summary}>{summary}</div>
                    <div className={styles.tags}>
                        {tags && tags.map((tag) =>
                            <span key={`${id}-${tag}`} >
                                {`#${tag} `}
                            </span>
                        )}
                        {tech && tech.map((tag) =>
                            <span key={`${id}-${tag}`} >
                                {`#${tag} `}
                            </span>
                        )}
                    </div>
                </div>

                {this.state.open &&
                    <div className={classnames(styles.overlay, { [styles.closing]: this.state.closing })}>
                        <Close onClick={this.onClose} color="#fafafa" className={styles.close} />
                        <div className={styles.inner}>
                            <div className={styles.header}>
                                <h1> {title} </h1>
                                <h2> {subtitle} </h2>
                            </div>
                            {imgs &&
                                <div className={styles.carousel}>
                                    {imgs.map((img) =>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/imgs/projects/${img}`}
                                            alt={img}
                                            key={img}
                                        />
                                    )}
                                </div>
                            }
                            <div className={styles.content}>
                                <div className={styles.left}>
                                    {date}

                                    {paragraphs && paragraphs.map((p, i) =>
                                        <p
                                            key={`p-${i}`}
                                            dangerouslySetInnerHTML={{ __html: p }}
                                        />
                                    )}

                                    {readmore &&
                                        <div className={styles.readmore}>
                                            <h3>Read More</h3>
                                            <ul>
                                                {readmore.map((link, i) =>
                                                    <li key={`event-${i}`}>
                                                        <a href={link.url}>
                                                            <img
                                                                // tslint:disable-next-line:max-line-length
                                                                src={`${process.env.PUBLIC_URL}/imgs/projects/${link.img}`}
                                                                alt={link.img}
                                                                key={link.img}
                                                            />
                                                            {link.text}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                    {links &&
                                        <div>
                                            <h3>Links</h3>
                                            <ul>
                                                {links.map((link, i) =>
                                                    <li key={`event-${i}`}>
                                                        <a href={link.url}>
                                                            {link.text}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                </div>
                                <div className={styles.right}>
                                    {events &&
                                        <div>
                                            <h3>Events</h3>
                                            <ul>
                                                {events && events.map((event, i) =>
                                                    <li key={`event-${i}`}>{event}</li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                    {awards &&
                                        <div>
                                            <h3>Awards</h3>
                                            <ul>
                                                {awards.map((a, i) =>
                                                    <li key={`award-${i}`}>{a}</li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                    {tags &&
                                        <div>
                                            <h3>Tags</h3>
                                            <ul>
                                                {tags.map((tag, i) =>
                                                    <li key={`tag-${i}`}>{tag}</li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                    {tech &&
                                        <div>
                                            <h3>Technologies</h3>
                                            <ul>
                                                {tech.map((t, i) =>
                                                    <li key={`tech-${i}`}>{t}</li>
                                                )}
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                }
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Project.tsx